/**
 * CreateCharacterPage - Создание персонажа (legacy)
 */

import React, { useEffect, useState } from "react";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import { ucpService } from "../../api/services/ucpService";
import { Toast } from "../../components/UI";

const CreateCharacterPage = () => {
    const [textSituation1, setTextSituation1] = useState([]);
    const [textSituation2, setTextSituation2] = useState([]);
    const [toast, setToast] = useState(null);

    const [val, setVal] = useState("");
    const [kventa, setKventa] = useState("");
    const [traits, setTraits] = useState("");
    const [skills, setSkills] = useState("");
    const [appearance, setAppearance] = useState("");
    const [sex, setSex] = useState("male");
    const [race, setRace] = useState("human");
    const [situation1, setSituation1] = useState("");
    const [situation2, setSituation2] = useState("");
    const [skin, setSkin] = useState(1);

    const availableSkins = {
        human: { male: 6, female: 6 },
        elf: { male: 1, female: 1 },
        dwarf: { male: 1, female: 0 },
        nimf: { male: 0, female: 1 },
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await ucpService.getRoleSituations();
                setTextSituation1(result?.situations?.[0] || {});
                setTextSituation2(result?.situations?.[1] || {});
            } catch (err) {
                console.error(err.message);
            }
        };
        fetchData();
    }, []);

    const handleRaceChange = (selectedRace) => {
        setRace(selectedRace);
        if (selectedRace === "nimf") {
            setSex("female");
        }
        if (selectedRace === "dwarf") {
            setSex("male");
        }
        setSkin(1);
    };

    const handleSexChange = (selectedSex) => {
        if (race !== "nimf" && race !== "dwarf") {
            setSex(selectedSex);
        }
        setSkin(1);
    };

    const handleSkinPrev = () => {
        if (skin > 1) {
            setSkin(skin - 1);
        }
    };

    const handleSkinNext = () => {
        if (skin < availableSkins[race][sex]) {
            setSkin(skin + 1);
        }
    };

    const handleCreateCharacter = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const payload = Object.fromEntries(formData.entries());
        if (Object.values(payload).some((value) => value.trim() === "")) {
            alert("Требуется заполнить все поля!");
            return;
        }
        try {
            const data = await ucpService.createCharacter({
                character_sex: payload.sex,
                character_race: payload.race,
                character_name: payload.character_name,
                character_prehistory: payload.character_prehistory,
                character_traits: payload.character_traits,
                character_skills: payload.character_skills,
                character_appearance: payload.character_appearance,
                role_situation_1: payload.id_situation1,
                role_answer_1: payload.character_situation1,
                role_situation_2: payload.id_situation2,
                role_answer_2: payload.character_situation2,
                character_skinVariable: payload.selected_skin,
            });
            switch (data.code) {
                case 200:
                    window.location.href = "/ucp/";
                    break;
                default:
                    console.log(data.status);
                    setToast({ message: data.status, type: "error" });
            }
        } catch (err) {
            console.error("Ошибка соединения:", err);
        }
    };

    return (
        <div className="ucp-main">
            {toast && (
                <Toast
                    message={toast.message}
                    type={toast.type}
                    duration={4500}
                    className="ucp-pages"
                    onClose={() => setToast(null)}
                />
            )}
            <div className="ucp-two-blocks-container ucp-two-blocks-container-create-person">
                <div>
                    <button
                        className="ucp-simple-blur-button ucp-button-back"
                        onClick={() => {
                            window.location.href = "/ucp";
                        }}
                    >
                        НАЗАД
                    </button>
                    <div className="character-body">
                        <img
                            src={
                                "/media/" +
                                race +
                                "_" +
                                sex +
                                "_" +
                                skin +
                                ".png"
                            }
                            alt=""
                        />
                        <span>
                            {(val.split(" ")[0] || "").toUpperCase()}
                            <br />
                            {val.split(" ").length > 1
                                ? val.split(" ")[1].toUpperCase()
                                : ""}
                            <br />
                            {val.split(" ").length > 2
                                ? val.split(" ")[2].toUpperCase()
                                : ""}
                        </span>
                    </div>
                    <div className="ucp-select-skins-container">
                        <button
                            className="ucp-button-previous"
                            onClick={handleSkinPrev}
                        ></button>
                        <span>
                            0{skin}/0{availableSkins[race][sex]}
                        </span>
                        <button
                            className="ucp-button-next"
                            onClick={handleSkinNext}
                        ></button>
                    </div>
                </div>
                <SimpleBar className="ucp-second-container">
                    <form onSubmit={handleCreateCharacter}>
                        <span>ВЫБОР ПОЛА</span>
                        <div className="ucp-buttons-container">
                            <div className="ucp-radio-button">
                                <input
                                    type="radio"
                                    id="male"
                                    name="sex"
                                    value="male"
                                    onChange={(e) =>
                                        handleSexChange(e.target.value)
                                    }
                                    disabled={race === "nimf"}
                                    checked={sex === "male"}
                                />
                                <label htmlFor="male">МУЖЧИНА</label>
                                <input
                                    type="radio"
                                    id="female"
                                    name="sex"
                                    value="female"
                                    onChange={(e) =>
                                        handleSexChange(e.target.value)
                                    }
                                    disabled={race === "dwarf"}
                                    checked={sex === "female"}
                                />
                                <label htmlFor="female">ЖЕНЩИНА</label>
                            </div>
                        </div>
                        <span>ВЫБОР РАСЫ</span>
                        <div className="ucp-buttons-container">
                            <div className="ucp-radio-button">
                                <input
                                    type="radio"
                                    id="human"
                                    name="race"
                                    value="human"
                                    onChange={(e) =>
                                        handleRaceChange(e.target.value)
                                    }
                                    defaultChecked
                                />
                                <label htmlFor="human">ЧЕЛОВЕК</label>
                                <input
                                    type="radio"
                                    id="dwarf"
                                    name="race"
                                    value="dwarf"
                                    onChange={(e) =>
                                        handleRaceChange(e.target.value)
                                    }
                                />
                                <label htmlFor="dwarf">КРАСНОЛЮД</label>
                                <input
                                    type="radio"
                                    id="elf"
                                    name="race"
                                    value="elf"
                                    onChange={(e) =>
                                        handleRaceChange(e.target.value)
                                    }
                                />
                                <label htmlFor="elf">ЭЛЬФ</label>
                                <input
                                    type="radio"
                                    id="nimf"
                                    name="race"
                                    value="nimf"
                                    onChange={(e) =>
                                        handleRaceChange(e.target.value)
                                    }
                                />
                                <label htmlFor="nimf">НИМФА</label>
                            </div>
                        </div>
                        <span>ИМЯ ПЕРСОНАЖА</span>
                        <input
                            type="text"
                            name="character_name"
                            className="ucp-simple-input-text"
                            placeholder="Имя персонажа"
                            maxLength={24}
                            minLength={2}
                            value={val}
                            onChange={(e) =>
                                setVal(
                                    e.target.value.replace(/[^а-яА-Я ]/g, ""),
                                )
                            }
                        />
                        <span>КВЕНТА ПЕРСОНАЖА</span>
                        <textarea
                            name="character_prehistory"
                            className="ucp-simple-input-text"
                            placeholder="Краткая предыстория персонажа"
                            maxLength={500}
                            minLength={20}
                            value={kventa}
                            onChange={(e) =>
                                setKventa(
                                    e.target.value.replace(/[&%#@*<>]/g, ""),
                                )
                            }
                            style={{ minHeight: "180px" }}
                        />
                        <textarea
                            name="character_traits"
                            className="ucp-simple-input-text"
                            placeholder="Черты характера персонажа"
                            maxLength={500}
                            minLength={20}
                            value={traits}
                            onChange={(e) =>
                                setTraits(
                                    e.target.value.replace(/[&%#@*<>]/g, ""),
                                )
                            }
                            style={{ minHeight: "180px" }}
                        />
                        <textarea
                            name="character_skills"
                            className="ucp-simple-input-text"
                            placeholder="Увлечения, умения, навыки"
                            maxLength={500}
                            minLength={20}
                            value={skills}
                            onChange={(e) =>
                                setSkills(
                                    e.target.value.replace(/[&%#@*<>]/g, ""),
                                )
                            }
                            style={{ minHeight: "180px" }}
                        />
                        <textarea
                            name="character_appearance"
                            className="ucp-simple-input-text"
                            placeholder="Внешний вид, особые приметы, привычки"
                            maxLength={500}
                            value={appearance}
                            onChange={(e) =>
                                setAppearance(
                                    e.target.value.replace(/[&%#@*<>]/g, ""),
                                )
                            }
                            style={{ minHeight: "180px" }}
                        />
                        <span>РОЛЕВЫЕ СИТУАЦИИ</span>
                        <div className="ucp-simple-info-block">
                            {textSituation1["content"]}
                        </div>
                        <input
                            type="hidden"
                            name="id_situation1"
                            value={textSituation1["id"]}
                        />
                        <textarea
                            name="character_situation1"
                            className="ucp-simple-input-text"
                            placeholder="Ответ на ролевую ситуацию"
                            maxLength={400}
                            minLength={20}
                            value={situation1}
                            onChange={(e) =>
                                setSituation1(
                                    e.target.value.replace(/[&%#@*<>]/g, ""),
                                )
                            }
                            style={{ minHeight: "150px" }}
                        />
                        <div className="ucp-simple-info-block">
                            {textSituation2["content"]}
                        </div>
                        <input
                            type="hidden"
                            name="id_situation2"
                            value={textSituation2["id"]}
                        />
                        <textarea
                            name="character_situation2"
                            className="ucp-simple-input-text"
                            placeholder="Ответ на ролевую ситуацию"
                            maxLength={400}
                            minLength={20}
                            value={situation2}
                            onChange={(e) =>
                                setSituation2(
                                    e.target.value.replace(/[&%#@*<>]/g, ""),
                                )
                            }
                            style={{ minHeight: "150px" }}
                        />
                        <input
                            type="hidden"
                            name="selected_skin"
                            value={skin}
                        />
                        <button
                            type="submit"
                            className="ucp-simple-yellow-button"
                            disabled={val.length < 5}
                        >
                            ЗАВЕРШИТЬ СОЗДАНИЕ ПЕРСОНАЖА
                        </button>
                    </form>
                </SimpleBar>
            </div>
        </div>
    );
};

export default CreateCharacterPage;
